export const EMPTY_SIMS_FETCH = 'moi/emptySims/EMPTY_SIMS_FETCH';
export const EMPTY_SIMS_RECEIVE = 'moi/emptySims/EMPTY_SIMS_RECEIVE';
export const NEW_SUBSCRIPTION = 'moi/emptysims/NEW_SUBSCRIPTION';
export const FREE_NUMBERS_FETCH = 'moi/emptysims/FREE_NUMBERS_FETCH';
export const FREE_NUMBERS_RECEIVE = 'moi/emptysims/FREE_NUMBERS_RECEIVE';
export const NEW_SUBSCRIPTION_FINISHED = 'moi/emptysims/NEW_SUBSCRIPTION_FINISHED';
export const ABLE_TO_ACTIVATE_FETCH = 'moi/emptysims/ABLE_TO_ACTIVATE_FETCH';
export const ABLE_TO_ACTIVATE_RECEIVE = 'moi/emptysims/ABLE_TO_ACTIVATE_RECEIVE';
